// Lodash extensions that might be of general value outside RivalIQ.

// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let _;
if (typeof window === 'undefined') {
    _ = require('lodash');
} else {
    _ = window._;
}

const _lodash_sum = _.sum;

(function () {
    'use strict';

    _.mixin({

        /**
         * Copies an object by evaluating all functions on the provided object
         * Values that are not functions are added directly
         * @param object
         * @param [{...*}] arguments
         */
        resultingObject: function (context, object) {

            const me = context || this;
            const args = Array.prototype.slice.call(arguments, 2);

            return _.reduce(object, function (memo, val, key) {
                const value = (_.isFunction(val) ? val.apply(me, args) : val);
                memo[key] = value;

                return memo;
            }, {});
        },

        /**
         * Returns a boolean indicating if the value is present
         */
        exists: function (value) {

            return !_.isUndefined(value) && !_.isNull(value);
        },

        sum: function (array) {
            array = _.map(array, (item) => {
                if (Number(item)) {
                    return Number(item);
                }
                // note: lodash 4 sum ignores falsy values but returns NaN for non-numerical strings
                // we'll set those non-numerical strings to null & continue with the sum
                // ie _.sum(['h', 1]) ==> 1
                return _.isNaN(item) ? item : 0;
            });
            return _lodash_sum(array);
        },

        sumBy: function (collection, path) {
            return _.sum(_.map(collection, path));
        }
    });
})();
